import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  scanButton: { color: '#30556B', backgroundColor: '#F4F4F4' },
  divider: { color: '#C6CAC6' },
}));
